import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const theme: ThemeApp['appComponents']['vectorSearch'] = {
  container: {
    backgroundColor: themeUi.semantic.color.background.neutral300
  },
  featureCard: {
    backgroundColor: themeUi.semantic.color.background.neutral100,
    borderColor: themeUi.semantic.color.border.neutral400,
    boxShadow: themeUi.core.shadow.shadow4
  },
  footerLinks: {
    color: themeUi.semantic.color.text.neutral600
  }
};

export default theme;
